import type { PropsWithChildren } from 'react'
import { ExternalLink } from 'lucide-react'
import { cn } from '~/utils'

type Props = PropsWithChildren<{
  className?: string
  linkUrl?: string
  linkLabel?: string
  title?: string
  description?: string
}>

export const ConfigSection = ({ className, children, linkLabel, linkUrl, description, title, ...props }: Props) => {
  return (
    <div {...props} className={cn('flex flex-col text-foreground', className)}>
      {title && <h3 className="text-lg font-medium">{title}</h3>}
      {description && (
        <p className="mb-4 text-sm text-muted-foreground">
          {description}
          {linkUrl && linkLabel && (
            <a
              className="inline-flex items-center gap-1 text-sm text-primary hover:underline"
              href={linkUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {linkLabel}
              <ExternalLink className="h-3 w-3" />
            </a>
          )}
        </p>
      )}
      {children}
    </div>
  )
}
